// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__Y-Tts","modal":"modal_modal__hd7Yy","header":"modal_header__e1lW0","closeBtn":"modal_closeBtn__llqZ7","body":"modal_body__6DtAY"};